import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAgency'

// LIST ALL TESTIMONIALS
export const testimonialList = (params = '') => Http.get(`/mundo-indie-project-testimonies${serialize(params)}`)
export const testimonialCreate = (params = '') => Http.post('/mundo-indie-project-testimonies', params)
export const testimonialByID = (params = '') => Http.get(`/mundo-indie-project-testimonies/${params}`)
export const testimonialUpdate = (params = '') => Http.put(`/mundo-indie-project-testimonies/${params.id}`, params)
export const testimonialDestroy = (params = '') => Http.delete(`/mundo-indie-project-testimonies/${params.id}`)
